import type { ClaimGoogleTransLang, StreamStatus } from '@/domains/claim-charting/types/enum';
import type { PsHttpSSE } from '@patsnap-utils/sse';

export interface ApiGetClaimFeatureRequest {
    patent_id: string;
}

interface SeparateClaimItem {
    indep_claim: boolean;
    name: string;
    separates: string[];
}

export interface ApiGetClaimFeatureResponse {
    status: StreamStatus;
    token_usage: TokenUsage;
    content: ClaimFeatureContent;
}

export interface TokenUsage {
    input_token_count: number;
    output_token_count: number;
    total_token_count: number;
}
export interface ClaimFeatureContent {
    claim_lang: ClaimGoogleTransLang;
    patent_id: string;
    pn: string;
    separate_claims: SeparateClaimItem[];
}

export const GetClaimFeature = Symbol.for('GetClaimFeature');

export interface GetClaimFeature {
    getClaimFeature(request: ApiGetClaimFeatureRequest): PsHttpSSE<ApiGetClaimFeatureResponse>;
}
